export default "__VITE_ASSET__D3UJ$MSM__"